import { FC } from "react"
import { useTranslation } from "react-i18next"
import { Box, Select, Tooltip, Typography } from "@strapi/design-system"
import { InfoIcon } from "lucide-react"
import { Errors } from "pages/Products/ProductPage/Errors"

interface SelectWithInfoTooltipProps {
  onChange: (e: any) => void
  value: string
  label: string
  description: string
  disabled?: boolean
  isOptional?: boolean
  children: React.ReactNode
  name?: string
  style?: any
  errors?: string[]
}

export const SelectWithInfoTooltip: FC<SelectWithInfoTooltipProps> = ({
  onChange,
  label,
  value,
  description,
  disabled = false,
  isOptional,
  children,
  errors,
  name = label,
  style: _style,
}) => {
  const { t } = useTranslation()

  return (
    <Box style={{ minWidth: "150px" }}>
      <Select
        name={name}
        disabled={disabled}
        label={
          <Box
            style={{
              gap: 4,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="pi">{label}</Typography>
            <Tooltip description={description}>
              <Box
                style={{
                  gap: 4,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <InfoIcon style={{ width: "16px", height: "16px", cursor: "pointer" }} />
              </Box>
            </Tooltip>
            <Typography
              style={{
                textAlign: "center",
                fontWeight: "500",
                fontSize: "12px",
                height: "12px",
                lineHeight: "12px",
                color: "#666684",
              }}
            >
              {isOptional ? t("selectWithInfoTooltip.optional") : ""}
            </Typography>
          </Box>
        }
        onChange={onChange}
        value={value}
      >
        {children}
      </Select>
      <Errors _errors={errors} />
    </Box>
  )
}
